import { authorizedFetch as fetch } from '@/helpers/authFetch';
import { externalServicesEndPoint, checkServiceOK } from './serviceConstants';

const externalServicesMonitoring = () => (
  fetch(`${externalServicesEndPoint}/monitoring`).then(checkServiceOK)
);

export default {
  externalServicesMonitoring,
};
